import React, {FC} from 'react';
import {CChart} from "@coreui/react-chartjs";
import {getStyle} from "@coreui/utils";
import {colors} from "../../../../colorsForCharts/colorsForCharts";

interface IChartsProps {
  labels: string[];
  data: any[];
}

const LineChart: FC<IChartsProps> = ({labels, data}) => {

  return (
    <>
      <CChart
        className={'line-chart'}
        type="line"
        data={{
          labels: labels,
          // @ts-ignore
          datasets: data?.map((el: any, index: number) => {
            // let dataValue = Object.entries(el)?.map(elem => elem[0] !== 'id' && elem[0] !== 'name' ? elem[1] : 0)?.filter(i => i !== 0)
            return {
              label: el.label,
              backgroundColor: colors[index],
              borderColor: colors[index],
              pointBackgroundColor: colors[index],
              pointBorderColor: "#fff",
              data: el.data || [],
              // data: dataValue?.length ? dataValue : []
              // fill: true
            }
          })
        }}
        options={{
          plugins: {
            legend: {
              labels: {
                color: getStyle('--cui-body-color'),
              }
            }
          },
          scales: {
            x: {
              grid: {
                color: getStyle('--cui-border-color-translucent'),
              },
              ticks: {
                color: getStyle('--cui-body-color'),
              },
            },
            y: {
              grid: {
                color: getStyle('--cui-border-color-translucent'),
              },
              ticks: {
                color: getStyle('--cui-body-color'),
              },
            },
          },
        }}
      />
    </>
  );
};

export default LineChart;